import {Injectable} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {GeospatialFilterStore} from '../../../api/geospatial-filter.store';
import {GenericFilterGroupAccordion} from '@theme/components/layout/control-panel/generic-filter-group-accordion';
import {OutageFilterGroup, SectionFilterMethodEnum} from '../../../api/geospatial-viewer-controls.service';

@Injectable()
export class OutageFilterControlsStore extends GenericFilterGroupAccordion {
    constructor(fb: FormBuilder, private geospatialFilterStore: GeospatialFilterStore) {
        super(fb);

        this.geospatialFilterStore.outageFilterSettings$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((settings: OutageFilterGroup[]) => {
                const generalFilterSettings = settings.filter(
                    (g) => g.sectionFilterMethod === SectionFilterMethodEnum.GENERIC_FILTERS,
                );
                this.filterGroupSettings.next(generalFilterSettings);
            });
    }
}
